<script setup>
import {defineProps} from "vue";
import useHelper from "@/composables/useHelper";

const props = defineProps({
    content: Object
});

const {getContentStatusText, getContentStatusClass} = useHelper();
</script>

<template>
    <div class="mb-3 text-xs">
        <span class="font-bold text-slate-600">{{ $tt('content_card__status_title') }}: </span>
        <span class="font-semibold" :class="getContentStatusClass(props.content.progress)">{{ getContentStatusText(props.content.progress) }}</span>
    </div>
</template>

